import { format, utcToZonedTime } from "date-fns-tz";

import logger from "@/utils/logger";

const getFormattedScheduleTime = (
  timeStart: string,
  timeEnd: string,
  timezone: string,
  hideDate = false
) => {
  let time = "";
  try {
    const zonedTimeStart = utcToZonedTime(timeStart, timezone);
    const zonedTimeEnd = utcToZonedTime(timeEnd, timezone);

    const monthAndDay = format(zonedTimeStart, "MMM dd");
    const startTime = format(zonedTimeStart, "hh:mma");
    const endTime = format(zonedTimeEnd, "hh:mma z", { timeZone: timezone });

    if (!hideDate) {
      time = `${monthAndDay} `;
    }

    time = `${time}${startTime}–${endTime}`;
  } catch (error) {
    logger.error(error, {
      details: "error while parsing schedule time",
      arguments: [timeStart, timeEnd],
    });
  }

  return time;
};

export default getFormattedScheduleTime;
